// Action descriptors + verbs for the workbench write path (HUB-407). Kept in a
// React-free module so both the live source (@hub/api) and the primitives can
// import them without pulling in the provider/hook machinery.

/** A mutation the workbench can submit against a bound entity. `kind` selects the
 *  server RPC the source dispatches to; `entityId` is the target work item. */
export interface ActionDescriptor {
  /** action verb — one of the ACTION_* constants below */
  kind: string;
  /** the entity the action targets (flows into the RPC + cache invalidation) */
  entityId?: string;
}

/** Transition a work item to a new status (WorkQueueService.TransitionStatus). The
 *  server validates the transition against the item's lifecycle and emits a
 *  `status_changed` activity event — the action enters the ledger (HUB-320). */
export const ACTION_TRANSITION_STATUS = 'workitem.transition';

/** Claim a work item for the current user (WorkQueueService.ClaimWorkItem). */
export const ACTION_CLAIM = 'workitem.claim';
